/**
 * A perda do dia: quantos trânsitos o prazo de 24 h levou hoje e quanto eles valiam (05/10).
 *
 * Mora no topo da Operação, ao lado de "Aprovados hoje", e no da SENATRAN — e não na régua.
 * A régua é a fila da tela (§4.1: cada cartão é um filtro do que está ali), e o que perdeu
 * o prazo já saiu das duas filas: virou não enviável. Este é o placar do dia, o par do
 * "Aprovados hoje" — o que se salvou e o que se perdeu.
 *
 * O clique abre a SENATRAN com o recorte `venceram_hoje`, a mesma definição que contou o
 * número (`AC04`). Com zero não há o que abrir, e a pílula fica apagada.
 */
import { Link } from "react-router";

import type { PerdidosHoje } from "../api/tipos";
import { Icone } from "../componentes/icones";
import { numeroLongo, reais } from "../formato";

export const DESTINO_DA_PERDA = "/senatran?recorte=venceram_hoje";

/** O valor como dá para afirmar: soma do que tem tarifa, e quantos ficaram de fora dela. */
function valorDaPerda(p: PerdidosHoje): string | null {
  if (p.quantidade === 0) return null;
  if (p.valor_centavos == null) return "sem tarifa";
  return p.sem_tarifa > 0
    ? `${reais(p.valor_centavos)} + ${numeroLongo(p.sem_tarifa)} sem tarifa`
    : reais(p.valor_centavos);
}

export function PerdaDoDia({ perdidos }: { perdidos: PerdidosHoje | null }) {
  if (!perdidos) return null;
  const valor = valorDaPerda(perdidos);
  const titulo =
    perdidos.quantidade === 0
      ? "Nenhum trânsito perdeu o prazo de 24 h hoje."
      : "Passaram das 24 h sem envio e viraram não enviáveis: sem cobrança e sem autuação. Clique para ver quais.";
  const corpo = (
    <>
      <Icone.Relogio />
      Perderam o prazo hoje
      <b className="mono text-[12.5px]">{numeroLongo(perdidos.quantidade)}</b>
      {valor && <span>· {valor}</span>}
    </>
  );
  const forma =
    "inline-flex items-center gap-1.5 rounded-pilula border px-2.5 py-1 text-[11px]";
  if (perdidos.quantidade === 0)
    return (
      <span
        title={titulo}
        className={`${forma} border-linha bg-painel-2 text-tinta-3`}
      >
        {corpo}
      </span>
    );
  return (
    <Link
      to={DESTINO_DA_PERDA}
      title={titulo}
      className={`${forma} border-vermelho-borda bg-vermelho-fundo font-semibold text-vermelho hover:brightness-110`}
    >
      {corpo}
    </Link>
  );
}
